/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TransactionDetailsParser = /* #__PURE__ */ parsers.object([
    ['initiatedAt', parsers.moment, 'initiated_at'],
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan', 'course')],
]);
export class TransactionDetails extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TransactionDetailsParser.decode(input).map(res => new TransactionDetails(res));
    }
    static unsafeDecode(input) {
        return TransactionDetails.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TransactionDetailsParser.encode(data);
    }
    static schema() {
        return TransactionDetailsParser.schema();
    }
}
